import React from "react";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";
import VenueGeneral from "./Tabs/VenueGeneral";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import AuthProvider from "../../auth/AuthProvider";
import { formatTitle } from "../../../utils/formatting";

function VenueForm() {
  return (
    <AuthProvider prefix={"venues"}>
      <JamezzFormV2
        computedPageTitle={function (model) {
          return formatTitle(this.pageTitle, model.name);
        }}
        endPoint={"core/venue"}
        pageTitle={"Venue"}
        rootRight={"vestigingen"}
        tabs={[
          {
            tabButton: <TranslationWrapper tDefault={"General"} tKey={"general"} />,
            tabContent: <VenueGeneral />,
          },
        ]}
      />
    </AuthProvider>
  );
}

export default VenueForm;
